import React, { FC } from 'react';

import { Box, Typography } from '@mui/material';

import { getEditedPropLabel } from './helper';
import styles from './styles';

interface IEditedFieldsModal {
  editedProps: string[];
  isTechnician: boolean;
}

const EditedFieldsModal: FC<IEditedFieldsModal> = ({
  editedProps,
  isTechnician,
}) =>
  (
    <Box sx={styles.container}>
      {editedProps.map((propName) =>
        (
          <Typography key={propName} sx={styles.field}>
            {getEditedPropLabel(propName, isTechnician)}
          </Typography>
        ))}
    </Box>
  );

export default EditedFieldsModal;
